// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2ioEs","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Reby"};